/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_Lines.js                                                                     */
/**********************************************************************************************************************/
/* Controller.Lines */

/**
 * @class this.Controller.Lines
 */
HafasWebapp.prototype.Controller.Lines = {
  linesGroups: {},
  activeRequests: 0,
  receivedResponses: 0,
  /**
   * Loads the index template file and calls renderIndex
   */
  index: function () {
    Hafas.Modules.Loader.loadTemplateFiles(['lines.index.html'], Hafas.bind(function () {
      Hafas.bind(this.Controller.Lines.renderIndex, this)();
    }, this));
  },
  /**
   * Render the result view and fire the line group context requests
   * @param {HCIResult} response HCI result with a lineGrpL from a request or stored history data
   */
  showResultOverview: function (response) {
    var me = this;
    if (Hafas.Modules.History) {
      Hafas.Modules.History.updateData("Lines", "index", response);
    }

    if (typeof Hafas.Config.showDataModel !== 'undefined' && Hafas.Config.showDataModel) {
      console.log('+++ Lines.showResultOverview +++ DEBUG Model +++', response)
    }
    this.response = response;

    // Render the skeleton for all lines (first hierarchy level)
    Hafas.Modules.Render.render({
      file: 'lines.index.html',
      target: 'HFS_LinesOverviewResults',
      template: 'Lines_TplOverview',
      model: response
    }, Hafas.bind(function () {
      // Check if the lineGrpL contains an grpCtx on each object
      // If so, we need to set up a follow-up request in order to retrieve the actual lines
      if (response.lineGrpL !== undefined) {
        this.Controller.Lines.resolveGroupListRequest.bind(this)(response.lineGrpL);
      }

      Hafas.ps.pub('/GUI/results/overview/show', [{}]);
      // is defined in classic-Version GUI-Functions
      Hafas.ps.pub('/GUI/window/scrollTo', ['top']);
      Hafas.ps.pub('/GUI/results/resize', [{container: me.resultOverviewContainer, appcontext: me.appContext}]);
      Hafas.ps.pub('/app/events/resize');
      Hafas.Util.gui.resetScrollTop()
    }, this));
  },
  /**
   * Fire requests for all line groups in the lineGrpL to get the lines; render lines overview if all requests are finished
   * @param {Array<HCILineGroup>} lineGrpL Line group list from the HCI
   * @param {undefined|string} id idResolved from the lineGroup, undefined in the first call
   * @param {undefined|number} depth Iteration depth, incremented in recursive calls
   */
  resolveGroupListRequest: function (lineGrpL, id, depth) {
    depth = depth || 1;
    var jnyFilter = Hafas.Config.Lines?.jnyFltrL || [];
    for (var i = 0; i < lineGrpL.length; i++) {
      var lineGroup = lineGrpL[i];
      var idToReferenceResult = id || lineGroup.idResolved;

      this.Controller.Lines.activeRequests++;
      // Get the lines for a line group context
      this.Controller.Lines.instance.getGrpCtx(lineGroup.grpCtx, {jnyFilter: jnyFilter}, function (originReferenceId, depthParam) {
        var me = this;
        return function (grpCtxResult) {
          me.Controller.Lines.receivedResponses++;
          if (grpCtxResult.lineGrpL !== undefined && depthParam <= 0) {
            // Recursive follow-up request
            me.Controller.Lines.resolveGroupListRequest.bind(me)(grpCtxResult.lineGrpL, originReferenceId, depthParam + 1);
          } else {
            me.Controller.Lines.linesGroups[originReferenceId] = grpCtxResult.lineGrpL;
          }
          if (me.Controller.Lines.activeRequests === me.Controller.Lines.receivedResponses) {
            me.Controller.Lines.renderMainOverview.bind(me)();
          }
        }
      }.bind(this)(idToReferenceResult, depth));
    }
  },
  /**
   * Request lines of a specific line group and render the group details
   * @param {Object} params object that holds all parameters for this function
   * @param {String} params.grpCtx grpCtx identifier
   * @param {String} params.title title of the line button that was clicked
   * @param {String} params.icoResovledKey Key to get the icoResolved via objectKeeper
   */
  getResultGroupByCtx: function (params) {
    params.icoResolved = Hafas.Modules.Render.objectKeeper.get(params.icoResolvedKey);
    var linesHeader = {
      icoResolved: params.icoResolved,
      nameS: params.title
    }
    var jnyFilter = Hafas.Config.Lines?.jnyFltrL || [];
    // Show loading spinner while data is loading
    this.Controller.Lines.renderLoadingScreen();

    this.Controller.Lines.instance.getGrpCtx(params.grpCtx, {jnyFilter: jnyFilter}, function (resolvedData) {
      // Render all lines of a group
      this.Controller.Lines.renderGroupDetails.bind(this)(resolvedData, linesHeader);
    }.bind(this));
  },
  /**
   * Renders a loading spinner
   */
  renderLoadingScreen: function () {
    Hafas.Modules.Render.render({
      file: 'lines.index.html',
      target: 'HFS_LinesOverviewList',
      template: 'Lines_TplLoadingScreen',
      model: {}
    }, Hafas.bind(function () {
    }.bind(this)));
  },
  /**
   * Renders the line group details
   * @param {Object} resolvedResponseData Transformed / resolved HCIResult with lines
   * @param {Object} linesHeader Information like icon and title about the clicked line
   */
  renderGroupDetails: function (resolvedResponseData, linesHeader) {
    if (Hafas.Modules.History) {
      Hafas.Modules.History.addOrUpdateData("Lines", "groupdetails", resolvedResponseData);
    }
    // Mark message group as read when visiting the details
    this.Controller.Lines.addLineToLocalStorage(resolvedResponseData);

    // Filter out lines without messages
    var linesWithMessages = resolvedResponseData.lines?.filter(function (line, index, originalArray) {
      return line.prodResolved?.msgL?.length > 0;
    });

    var model = {
      lines: linesWithMessages,
      linesHeader: linesHeader // Needed to show icon and title for line details if no lines with messages are left to show; Can also be used as a header in line details view with multiple lines
    }

    Hafas.Modules.Render.render({
      file: 'lines.index.html',
      target: 'Lines_ResultDetail',
      template: 'Lines_TplGroupDetails',
      model: model
    }, Hafas.bind(function () {
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/show', [{}]);
      Hafas.Util.gui.resetScrollTop();
    }.bind(this)));
  },
  /**
   * Renders the main overview container for all line groups / products
   */
  renderMainOverview: function () {
    var lineGroups = this.Controller.Lines.linesGroups;
    for (var lineGroupsKey in lineGroups) {
      var currentLineGroup = lineGroups[lineGroupsKey];

      // Set the read status of lines with messages
      Hafas.bind(this.Controller.Lines.isMessageRead, this)({lines: currentLineGroup});

      var targetContainer = Hafas('#' + lineGroupsKey, false);
      Hafas.Modules.Render.render({
        file: 'lines.index.html',
        template: 'Lines_TplOverviewMainGroups',
        target: targetContainer,
        model: {
          lineGroups: currentLineGroup
        }
      }, Hafas.bind(function (html) {
        Hafas.Util.gui.resetScrollTop();
      }, this));
    }
  },
  /**
   * Iterates a message list and checks if there are unread messages based on the storage; Enables the readAll button if there are unread messages
   * @param {Array<HCIMessage>} msgL Message list which holds the messages to check against the storage
   * @param {Object} line Resolved line group which gets the readMarker flag
   */
  updateMessageReadStatuses: function (msgL, line) {
    msgL = msgL || [];
    if (Hafas.Util.isCookieTypeActive('functional') === false) {
      return;
    }
    var storage = Hafas.Core.newType("hafasStorage");
    var storedLinesNews = storage.get('LinesNews_' + Hafas.Config.Storage.id);
    var _linesLocalStorage = JSON.parse(storedLinesNews);
    var readAllBtn = Hafas('#HFS_Lines_ReadAll', false);

    for (var m = 0; m < msgL.length; m++) {
      line.readMarker = true;
      if (_linesLocalStorage) {
        if (_linesLocalStorage._markReadAll > msgL[m].himResolved?.lModJsTimestamp) {
          line.readMarker = false;
        } else if (_linesLocalStorage.markedLines !== undefined) {
          var isLineStored = _linesLocalStorage.markedLines.find(x => x._grpCtx === line.grpCtx);
          if (isLineStored && isLineStored._timeStamp > msgL[m].himResolved?.lModJsTimestamp) {
            line.readMarker = false;
          }
        }
      }
      // Check if some read marker is set, then don't disable the all messages read button
      if (line.readMarker === true && readAllBtn !== null) {
        readAllBtn.disabled = false;
      }
    }
  },
  /**
   * Iterates through all lines of a group in order to update the message read statuses
   * @param {Object} resolvedLineGroup Resolved line group
   */
  isMessageRead: function (resolvedLineGroup) {
    var lines = resolvedLineGroup.lines || [];
    for (var l = 0; l < lines.length; l++) {
      var msgL = lines[l].msgL;
      if (msgL) {
        this.Controller.Lines.updateMessageReadStatuses(msgL, lines[l]);
      }
    }
  },
  /**
   * Marks a line as read by writing into the storage
   * @param {Object} resolvedResponseData Transformed / resolved HCIResult with lines
   */
  addLineToLocalStorage: function (resolvedResponseData) {
    if (Hafas.Util.isCookieTypeActive('functional') === false) {
      return;
    }
    var storage = Hafas.Core.newType("hafasStorage");
    var storageKey = 'LinesNews_' + Hafas.Config.Storage.id;
    var storedLinesNews = storage.get(storageKey);
    var _linesLocalStorageData = JSON.parse(storedLinesNews);

    var newMarkedLine = {
      _grpCtx: resolvedResponseData.grpCtx,
      _timeStamp: new Date().getTime()
    };

    var linesData = {};
    if (_linesLocalStorageData !== null) {
      linesData = _linesLocalStorageData;
      if (_linesLocalStorageData._markReadAll !== undefined && _linesLocalStorageData._markReadAll > newMarkedLine._timeStamp) {
        // When the readAll button was used, we still have to check if there are newer messages, so also check its timestamp
        return;
      }
    }

    linesData.markedLines = linesData.markedLines || [];
    // Remove old IDs when visiting lines details with saved read status again
    for (var l = linesData.markedLines.length - 1; l >= 0; l--) {
      var currentMarkedLine = linesData.markedLines[l];
      if (currentMarkedLine._grpCtx === resolvedResponseData.grpCtx) {
        linesData.markedLines.splice(l, 1);
      }
    }

    linesData.markedLines.push(newMarkedLine);
    linesData.markedLines = linesData.markedLines.filter((line, index, markedLines) => markedLines.indexOf(line) === index);

    storage.set(storageKey, JSON.stringify(linesData));
  },
  /**
   * Marks all messages as read and disables the readAll button
   */
  markMessagesAsRead: function () {
    if (Hafas.Util.isCookieTypeActive('functional') === false) {
      return;
    }
    var currentTimeStamp = new Date().getTime();
    var storage = Hafas.Core.newType("hafasStorage");
    storage.set('LinesNews_' + Hafas.Config.Storage.id, JSON.stringify({_markReadAll: currentTimeStamp}));

    Hafas('.lyr_readMarker', true).forEach(function (lineDomElement) {
      lineDomElement.removeClassName('lyr_readMarker');
    });

    var readAllBtn = Hafas('#HFS_Lines_ReadAll', false);
    if (readAllBtn !== null) {
      readAllBtn.disabled = true;
    }
  },
  /**
   * Creates the index model to be used in renderIndex
   * @returns {{}} lines feature index model
   */
  createIndexModel: function () {
    var model = {};
    return model;
  },
  /**
   * Renders the lines index view and calls follow-up requests for the lines
   */
  renderIndex: function () {
    var me = this;
    var model = Hafas.bind(this.Controller.Lines.createIndexModel, this)();

    if (Hafas.Modules.History) {
      Hafas.Modules.History.addData("Lines", "index", {});
    }

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ Lines.index +++ DEBUG Model +++', model)
    }

    // close all open tabs and hide the form which is not used in lines feature
    Hafas.ps.pub('/GUI/tabs/closeAll');
    Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'Lines'}]);

    Hafas.Modules.Render.render({
      file: 'lines.index.html',
      target: 'Lines_ResultOverview',
      template: 'Lines_TplIndex',
      model: model
    }, Hafas.bind(function () {
      Hafas.ps.pub('/GUI/results/overview/show', [{}]);
      Hafas.ps.pub('/GUI/tabNavigationHeading/show', [{}]);
      Hafas.ps.pub('/GUI/window/scrollTo', ['top']);
      Hafas.ps.pub('/app/events/renderDone');
      Hafas.ps.pub('/GUI/results/resize', [{container: me.resultOverviewContainer, appcontext: me.appContext}]);
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
      Hafas.Util.gui.resetScrollTop()

      // Call the follow-up request to search for line groups
      var jnyFilter = Hafas.Config.Lines?.jnyFltrL || [];
      this.Controller.Lines.instance.search({
        jnyFilter: jnyFilter,
        callback: Hafas.bind(me.Controller.Lines.showResultOverview, me)
      });
    }, this));
  },
  /**
   * Handles the view rendering on history navigation
   * @param {Object} histData Stored data from the history module
   */
  restoreView: function (histData) {
    var view = histData.view;
    switch (view) {
      case "index":
        Hafas.ps.pub('/GUI/tabNavigationHeading/show');
        Hafas.bind(this.Controller.Lines.showResultOverview, this)(histData.data);
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        Hafas.ps.pub('/GUI/results/overview/show', [{}]);
        break;
      case "groupdetails":
        Hafas.bind(this.Controller.Lines.renderGroupDetails, this)(histData.data);
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/details/show', [{}]);
        break;
    }
  },
  /**
   * Called when a view is closed on history navigation
   * @param {Object} histData Stored data from the history module
   */
  closeView: function (histData) {
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        break;
      case "groupdetails":
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }
  },
  /**
   * Called when the feature is left
   */
  cleanup: function () {
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
  }
};
